import React, { useState, useEffect } from 'react'
import { useHistory, useLocation } from 'react-router-dom';
import { Box, Grid } from '@mui/material';
import { Save } from '@mui/icons-material';
import { Button } from '../lib/common';
import Layout from './layout';
import { colors } from '../lib/styles';
import tabs from '../lib/client-tabs';
import disclaimer from '../lib/disclaimer';

const styles = {
  wrapper: {
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
    height: 'calc(100vh - 95px)',
    overflow: 'hidden',
  },
  topNav: {
    width: '100%',
    backgroundColor: '#fff',
    top: 0,
  },
  mainView: {
    width: '100%',
    flexGrow: 1,
    backgroundColor: '#D0DFF9',
    overflowY: 'auto',
    height: '100%',
  },
  buttonContainer: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'stretch',
    flexWrap: 'wrap',
    gap: '10px',
    padding: 0,
    margin: 0,
    height: '60px',
  }
}

function IncomePlanWrapper({ handleSubmit, children }) {
  const history = useHistory();
  const location = useLocation();
  const { pathname } = location;
  const [activeButton, setActiveButton] = useState('');
  const clientId = pathname.split('/')[2]; // Extract client ID from URL path

  useEffect(() => {
    const activeTab = tabs.find(tab => tab.path && pathname.includes(tab.path)) || tabs[0];
    setActiveButton(activeTab.label);
  }, [pathname]);

  const handleSave = () => {
    if (handleSubmit) {
      handleSubmit();
    }
  };

  const handleButtonClick = (buttonName) => {
    setActiveButton(buttonName);
    handleSave();
    
    const tab = tabs.find(tab => tab.label === buttonName);
    if (tab) {
      const path = tab.path ? `${tab.path}` : '';
      history.push(`/clients/${clientId}${path}`);
    }
  }

  return (
    <Layout>
      <div style={styles.wrapper}>
        <div style={styles.topNav}>
          <div style={styles.buttonContainer}>
            <Button 
              endIcon={<Save />} 
              onClick={handleSave}
              variant="contained"
              sx={{ 
                fontFamily: 'Maven Pro, Roboto, Circular Std, sans-serif', 
                height: '100%',
                backgroundColor: '#1d428a',
                '&:hover': {
                  backgroundColor: '#15316a',
                }
              }}
            >
              Save
            </Button>
            {tabs.map((tab) => (
              <Button
                key={tab.label}
                variant="default"
                onClick={() => handleButtonClick(tab.label)}
                sx={{
                  fontFamily: 'Maven Pro, Roboto, Circular Std, sans-serif',
                  fontSize: 16,
                  fontWeight: activeButton === tab.label ? 'bold' : 'normal',
                  color: activeButton === tab.label ? colors.primaryColor : colors.black,
                  borderBottom: activeButton === tab.label ? '3px solid #1d428a' : 'none',
                  backgroundColor: activeButton === tab.label ? '#D0DFF9' : 'transparent',
                  marginRight: '10px',
                  textAlign: 'center',
                  justifyContent: 'center',
                  height: '100%',
                  '&:hover': {
                    backgroundColor: '#D0DFF9',
                  },
                }}
              >
                {tab.label}
              </Button>
            ))}
          </div>
        </div>
        <div style={styles.mainView}>
          {children}
          <Box sx={{ flexGrow: 1, marginTop: '10px' }}>
            <Grid container spacing={2}>
              <Grid item xs={12}>
                <div style={{ 
                  padding: '15px', 
                  fontSize: '0.9rem',
                  color: '#555'
                }}>
                  <span style={{ fontWeight: 'bold', color: '#1d428a' }}>Disclaimer:</span> {disclaimer}
                </div>
              </Grid>
            </Grid>
          </Box>
        </div>
      </div>
    </Layout>
  )
}

export default IncomePlanWrapper